import { action, makeObservable, observable, computed } from "mobx";

class ArticleQueryStore {
    constructor(rootStore) {
        this.rootStore = rootStore;

        makeObservable(this);
    }
    

    @observable activeTags = {
    };
    

    activeQueryArticles = [];
    allArticles = [];
    allTags = [];

    
    @observable isSearching = false;
    @observable activeDataQueryID = undefined;
    @observable animateTransition = false;
    @observable activeTagPageIdx = undefined;
    

    @computed get activeTagsArray() {
        return Object.keys(this.activeTags)
    }

    @computed get canPerformQuery() {
        return this.activeTagsArray.length > 0
    }

    @computed get canAddTag() {
        return this.activeTagsArray.length < 3
    }

    @computed get canClear() {
        return this.canPerformQuery || !!this.activeDataQueryID;
    }

    @computed get numTagsPerPage() {
        return this.rootStore.uiStore.isMobile ? 8 : 9
    }

    @computed get numTagPages() {
        
        return Math.ceil(this.allTags.length / this.numTagsPerPage)
    }

    @computed get activeTagPage() {
        const start = (this.activeTagPageIdx) * this.numTagsPerPage;
        const end = start + this.numTagsPerPage;

        return this.allTags.slice(start, end);
    }

    @action.bound updateIsSearching(isSearching) {
        this.isSearching = isSearching;
    }

    @action.bound updateActiveTagsFromArray(tags) {
        this.activeTags = {};
        tags.forEach(tag => {
            this.activeTags[tag] = true;
        })
    }

    @action.bound updateActiveTags(tag) { 
        if (this.activeTags[tag]) {
            delete this.activeTags[tag]
        }
        else {
            if (this.canAddTag) {
                this.activeTags[tag] = true
            }
        }
    }

    @action.bound setAllArticles(data) {
        this.allArticles = data;
    }

    @action.bound performQuery(transitionFlag = false) {
        

        const activeQueryArticles = [];
        
        this.allArticles.forEach(article => {
            
            let isMatch = false;
            if (!article.node.tags) return
            article.node.tags.forEach(articleTag => {
                if (this.activeTags[articleTag.name]) {
                    isMatch = true;
                }
            })

            if (isMatch) {
                activeQueryArticles.push(article)
            }
        });


        this.activeDataQueryID = Math.random();
        this.activeQueryArticles = activeQueryArticles;

        this.animateTransition = transitionFlag;
    }

    @action.bound clearQuery() {
        this.activeDataQueryID = undefined;
        this.activeQueryArticles = [];
        this.activeTags = {};
    }

    @action.bound setTags(data) {
        this.allTags = data;
        this.activeTagPageIdx = 0;
    }

    @action.bound incrementTagPage() {
        if (this.activeTagPageIdx >= this.numTagPages -1) return

        this.activeTagPageIdx++;
    }


    @action.bound decrementTagPage() {
        if (this.activeTagPageIdx <= 0) return
        this.activeTagPageIdx--;
    }

    // @action.bound setAc

}




export default ArticleQueryStore;